import React, { useCallback, useState } from 'react';

import { Flex, Portal } from '@chakra-ui/react';
import '@draft-js-plugins/mention/lib/plugin.css';
import { useDebounce } from 'components/hooks/useDebounce';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { useMentionCompetencyQuery } from './hooks/dataHooks';

export const EntryComponent = ({ ...props }) => {
  const { mention } = props;
  const { name, uuid } = mention ?? {};
  return (
    <Flex {...props} key={uuid} alignItems="center" height="44px" p="12px">
      <TextBodyMedium>{name}</TextBodyMedium>
    </Flex>
  );
};

const CompetencySuggestions = ({
  CompetencyMentionSuggestions,
  widgetType,
  usePortalForSuggestions,
  portalParentRef,
  ...props
}) => {
  //   mention plugin states
  const [mentionOpen, setMentionOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 150);

  const { data: suggestions = [], isLoading } = useMentionCompetencyQuery({
    value: debouncedSearchTerm,
    widgetType,
    limit: 30,
  });

  const onOpenChange = useCallback((open) => {
    setMentionOpen(open);
  }, []);
  const onSearchChange = useCallback(({ value }) => {
    setSearchTerm(value);
  }, []);

  if (usePortalForSuggestions) {
    return (
      <Portal containerRef={portalParentRef}>
        <CompetencyMentionSuggestions
          open={mentionOpen}
          onOpenChange={onOpenChange}
          suggestions={suggestions}
          onSearchChange={onSearchChange}
          entryComponent={EntryComponent}
          {...props}
        />
      </Portal>
    );
  }

  return (
    <CompetencyMentionSuggestions
      open={mentionOpen}
      onOpenChange={onOpenChange}
      suggestions={suggestions}
      onSearchChange={onSearchChange}
      entryComponent={EntryComponent}
      {...props}
    />
  );
};

export { CompetencySuggestions };
